module.exports = __webpack_public_path__ + "img/clean_T.c74f5257.png";